import { useState } from 'react';

import { TabbedContentTabs } from '@klv/molecules/tabbed-content-tabs';
import { generateClassName } from '@klv/shared/utils/functions';

import { TabbedComponentLoop } from './tabbedComponentLoop';

import * as styles from './styles/tabbedContent.module.scss';

import type { ITabbedContent } from './types';


const TabbedContent = ({
  className = '',
  containerClassName = '',
  eyebrow = '',
  headline = '',
  subhead = '',
  useUnderlineVariant,
  tabs,
  tabBarClassName = '',
}: ITabbedContent) => {
  const [activeTab, setActiveTab] = useState(0);
  
  const hasGalleryComponent = tabs.some(tab =>
    tab?.components?.some(component => component.componentType === 'GalleryComponent'),
  );
  
  return (
    <div className={containerClassName}>
      <div className={generateClassName([className, styles.tabbedContent])}>
        {eyebrow || headline || subhead ? (
          <div className="grid">
            {eyebrow && <div className={generateClassName(['eyebrow', styles.tabsEyebrow])}>{eyebrow}</div>}
            {headline && <h2 className={generateClassName(['h1', styles.tabsHeadline])}>{headline}</h2>}
            {subhead && <div className={generateClassName(['h6', styles.tabsSubhead])}>{subhead}</div>}
          </div>
        ) : ''}
        <TabbedContentTabs
          activeTab={activeTab}
          className={tabBarClassName}
          setActiveTab={setActiveTab}
          tabs={tabs.map((tab) => tab.tabLabel)}
          useUnderlineVariant={useUnderlineVariant}
        />

        <div className={ !hasGalleryComponent ? styles.tabGrid : ''}>
          {tabs.map(({ children, ...tab }, tabIndex) => (
            <div
              key={tab.tabLabel}
              className={generateClassName([
                'panel',
                styles.panel, 
                activeTab === tabIndex ? styles.activePanel : '',
              ])}
            >
              {children ? children : <TabbedComponentLoop {...tab} />}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TabbedContent;
